import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Icon, IconButton, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { Environment } from '../../../shared/environment';
import { ColheitasService, IListagemColheita } from '../../../shared/services/api/ColheitasService';
import { FerramentasDaListagemColheitas } from '../../../shared/components';
import dayjs from 'dayjs';

export const ListagemDeColheitas: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<IListagemColheita[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalQtd, setTotalQtd] = useState(0);
  const [vlrtotal, setVlrTotal] = useState(0);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [autoComplete, setAutoComplete] = useState(true);
  const [fazendas, setFazenda] = useState(true);
  const [numero, setNumero] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [iditem, setIditem] = useState('');

  const codfaz = useMemo(() => {
    return searchParams.get('codfaz') || '0';
  }, [searchParams]);

  const guuidcolhedor = useMemo(() => {
    return searchParams.get('guuidcolhedor') || '';
  }, [searchParams]);

  const dataInicial = useMemo(() => {
    return searchParams.get('datainicial') || dayjs().startOf('month').format('DD/MM/YYYY').toString();
  }, [searchParams]);

  const dataFinal = useMemo(() => {
    return searchParams.get('datafinal') || dayjs().format('DD/MM/YYYY').toString();
  }, [searchParams]);

  const tipo = useMemo(() => {
    return searchParams.get('tipo') || 'c.codfaz';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  useEffect(() => {
    if (tipo === 'c.codfaz') {
      setFazenda(true);
      setAutoComplete(false);
      setNumero(false);
      setRows([]);
      setSearchParams({ tipo: 'c.codfaz', pagina: '1' }, { replace: true });
      setTotalCount(0);
    }
    else if (tipo === 'c.guuidcolhedor') {
      setAutoComplete(true);
      setFazenda(false);
      setNumero(false);
      setRows([]);
      setSearchParams({ tipo: 'c.guuidcolhedor', pagina: '1' }, { replace: true });
      setTotalCount(0);
    }
    else {
      setAutoComplete(false);
      setFazenda(false);
      setNumero(true);
      setRows([]);
      setSearchParams({ tipo: 'co.numero', pagina: '1' }, { replace: true });
      setTotalCount(0);
    }
  }, [tipo]);

  const handleDelete = (idi: string) => {
    setOpenConfirm(true);
    setIditem(idi);
  };

  const handleConfirmDelete = () => {
    ColheitasService.deleteById(iditem)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      if (tipo === 'c.guuidcolhedor' && guuidcolhedor != '') {
        setIsLoading(true);
        ColheitasService.getAll(pagina, tipo, guuidcolhedor, dataInicial, dataFinal)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setVlrTotal(result.vlrTotal);
              setTotalQtd(result.totalQtd); 
              setTotalCount(result.totalCount);
              setRows(result.data);
            }
          });
      } else {
        setIsLoading(true);
        ColheitasService.getAll(pagina, tipo, codfaz, dataInicial, dataFinal)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setVlrTotal(result.vlrTotal);
              setTotalQtd(result.totalQtd); 
              setTotalCount(result.totalCount);
              setRows(result.data);
            }
          });
      }
    }
  };


  useEffect(() => {
    if (tipo === 'c.guuidcolhedor' && guuidcolhedor != '') {
      setIsLoading(true);
      ColheitasService.getAll(pagina, tipo, guuidcolhedor, dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setVlrTotal(result.vlrTotal);
            setTotalQtd(result.totalQtd);  
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    } else {
      setRows([]);
    }
  }, [guuidcolhedor, pagina, dataInicial, dataFinal]);

  useEffect(() => {
    if (tipo === 'c.codfaz' && codfaz != '') {
      setIsLoading(true);
      ColheitasService.getAll(pagina, tipo, codfaz, dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setVlrTotal(result.vlrTotal);
            setTotalQtd(result.totalQtd); 
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    } else {
      setRows([]);
    }
  }, [codfaz, pagina, dataInicial, dataFinal]);

  useEffect(() => {
    if (tipo === 'co.numero' && busca != '') {
      setIsLoading(true);
      ColheitasService.getAll(pagina, tipo, busca, dataInicial, dataFinal)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setVlrTotal(result.vlrTotal);
            setTotalQtd(result.totalQtd); 
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    } else {
      setRows([]);
    }
  }, [busca, pagina, dataInicial, dataFinal]);

  return (
    <LayoutBaseDePagina
      titulo='Listagem de Colheitas'
      barraDeFerramentas={
        <FerramentasDaListagemColheitas
          mostrarInputBasicSelect
          mostrarAutoComplete={autoComplete}
          mostrarInputFazenda={fazendas}
          mostrarInputBusca={numero}
          dataInicial={dataInicial}
          dataFinal={dataFinal}
          textoDoSelect={tipo}
          textoDaBusca={busca}
          QtdTotal={totalQtd}
          VlrTotal={vlrtotal}
          aoMudarTextoDeBusca={texto => setSearchParams({ busca: texto, tipo: tipo,  datainicial: dataInicial, datafinal: dataFinal,  pagina: '1' }, { replace: true })}
          aoMudarFazenda={idFaz => setSearchParams({ codfaz: idFaz.toString(), pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
          aoMudarDataInicial={datainicial => setSearchParams({ tipo: tipo, pagina: '1', guuidcolhedor: guuidcolhedor, codfaz: codfaz, datainicial: datainicial, datafinal: dataFinal }, { replace: true })}
          aoMudarDataFinal={datafinal => setSearchParams({ tipo: tipo, pagina: '1', guuidcolhedor: guuidcolhedor, codfaz: codfaz, datainicial: dataInicial, datafinal: datafinal }, { replace: true })}
          aoMudarTextoDoSelect={textoselect => setSearchParams({ tipo: textoselect, pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
          aoMudarTextoDoColhedor={(texto, texto1) => setSearchParams({ guuidcolhedor: texto, tipo: tipo, pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
          dadosSelecao={[
            { nameBD: 'c.codfaz', descricao: 'Fazenda' },
            { nameBD: 'c.guuidcolhedor', descricao: 'Colhedor' },
            { nameBD: 'co.numero', descricao: 'Numero' },
          ]}
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
                Nâo
              </Button>
            </>
          }
        >
          Tem certeza que deseja excluir este registro?
        </Alert>
      </Snackbar>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table size='small'>
          <TableHead sx={{ backgroundColor: '#5E8A71' }}>
            <TableRow>
              <TableCell style={{ color: '#fff' }} align='center'>Data</TableCell>
              <TableCell style={{ color: '#fff' }}>Nome</TableCell>
              <TableCell style={{ color: '#fff' }} align='center'>numero</TableCell>
              <TableCell style={{ color: '#fff' }}>Fazenda</TableCell>
              <TableCell style={{ color: '#fff' }} align='center'>Area</TableCell>
              <TableCell style={{ color: '#fff' }} align='center'>Quadra</TableCell>
              <TableCell style={{ color: '#fff' }}>Código Verificador</TableCell>
              <TableCell style={{ color: '#fff' }} align='right'>Qunatidade</TableCell>
              <TableCell style={{ color: '#fff' }} align='right'>Valor</TableCell>
              <TableCell style={{ color: '#fff' }} align='right'>Total</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.guuidcolheita}
                hover
                sx={{ cursor: 'pointer' }}
              >
                <TableCell style={{ width: 100, color: row.status == 1 ? 'inherit' : '#db4a39' }} align='center'>{dayjs(row.datalan).format('DD/MM/YYYY')}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} >{row.nome}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='center'>{row.numero}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} >{row.fazenda}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='center'>{row.area}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='center'>{row.quadra}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} >{row.codverificador}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='right' >{row.qtd.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='right' >{row.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell style={{ color: row.status == 1 ? 'inherit' : '#db4a39' }} align='right' >{row.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell>
                  <IconButton disabled={row.status == 1 ? isLoading : true} size="small" onClick={() => { handleDelete(row.guuidcolheita); }}>
                    <Icon>delete</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={11}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > 12) && (
              <TableRow>
                <TableCell colSpan={11}>
                  <Pagination
                    page={pagina}
                    count={Math.ceil(totalCount / 12)}
                    onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString(), tipo: tipo, guuidcolhedor: guuidcolhedor, codfaz: codfaz, datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  );
};